import { TableCell } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import CCOrderChancesTable from "../ChancesTable";
import Modal from "../../../Components/Modal/Modal";
import Button from "../../../Components/Button";
import TableTemplate, { IAdditional } from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { ICCOrderTableReport } from "src/Interfaces/ccOrder";
import {
  getCCOrderBrokerTradeTable,
} from "src/Requests/ccOrder";

const AdditionalHeader: React.FC = () => {
  return (
    <>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: ICCOrderTableReport;
  onAction: () => void;
}> = ({ row }) => {
  const [isChancesOpen, setIsChancesOpen] = React.useState(false);
  const [isBrokerOrdersModalOpen, setIsBrokerOrdersModalOpen] =
    React.useState(false);

  const btnClickHandler = () => {
    setIsChancesOpen(true);
  };

  return (
    <>
      <TableCell>
        {isBrokerOrdersModalOpen ? (
          <Modal title="سفارشات"
            UI={
              <TableTemplate<{ id: number }, any>
                refreshTableTime={5000}
                getDataTable={(_, offset, pageSize) =>
                  getCCOrderBrokerTradeTable({ id: row.id }, offset, pageSize)
                }
                TableUI={({ reports, onAction }) => (
                  <CommonTableUI reports={reports} onAction={onAction} />
                )}
              />
            }
            onClose={() => setIsBrokerOrdersModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsBrokerOrdersModalOpen(true)}
          text="سفارشات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>

      <TableCell>
        {isChancesOpen ? (
          <Modal title="شانس‌ها"
            UI={
              <CCOrderChancesTable searchParam={{ id: row.id }} />
            }
            onClose={() => setIsChancesOpen(false)}
          />
        ) : null}
        <Button
          onClick={btnClickHandler}
          text="شانس ها"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<ICCOrderTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
